// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"fb6963a6","rightPanelContainer":"cc611681","chatRightPanelContainer":"cc4f53c6","externalForm":"bbf11bf7"};